<template>

  <template v-if="inclFB">GraficosLiveCentros: beg template<br></template>

  <div>
 
    <ModalGraficoUnidadLive v-if="modalgraficolivestate" :legendsFullWidth="true" :objJaula="objJaulaSeleccionada" :noShowSetpoint="true"
      :startDate="startDate" :endDate="endDate" @close="closeModalGraficoLive"> </ModalGraficoUnidadLive>

    <ModalGraficoUnidad v-if="modalgraficostate" :legendsFullWidth="true"
       :objJaula="objJaulaSeleccionada" :noShowSetpoint="true"
      :startDate="startDate" :endDate="endDate" @close="closeModalGrafico" />

 
    <!-- Ini leyendas -->
    <div v-if="!legendsFullWidth || legendsFullWidth" :class="[
      'grid items-stretch gap-0 mx-auto bg-gray-100 rounded-lg shadow-lg mb-0 pt-1',
      legendsFullWidth ?
        'grid-cols-1 lg:grid-cols-6 pr-12 pl-6' : // 1 col móvil, 6 col pantalla grande
        'grid-cols-1 lg:grid-cols-4 pl-1 pr-1',
      'w-full'
    ]">


  <!-- Primera columna -->
  <div class="text-center   pl-0 h-full   ">
   <span class="text-xs font-bold">{{ $t('o2_disuelto') }} mg/l</span>
  </div>

  <!-- Segunda columna -->
  <div class="text-center ml-1   mb-1 h-full flex flex-col justify-center">
    <div class="flex justify-between">
      <div class="w-1/2 text-left">
        <div class="mt-1 h-1 bg-[#01FFFF] shadow-lg ml-auto"></div>
      </div>
      <div class="w-1/2 text-right">
        <div class="mt-1 h-1 bg-[#0099FF] shadow-lg ml-auto"></div>
      </div>
    </div>
    <div class="flex justify-between mt-1">
      <div class="w-1/2 text-left">
        <span class="text-[#00e0e0] text-xs">{{ $t('con_inyeccion') }}</span>
      </div>
      <div class="w-1/2 text-left">
        <span class="text-[#0099FF] text-xs">{{ $t('sin_inyeccion') }}</span>
      </div>
    </div>
  </div>

  <!-- Tercera columna -->
  <div class="text-center w-full h-full  ">
    <span class="text-xs font-bold">{{ $t('temperatura_celsius') }}</span>
  </div>

  <!-- Cuarta columna -->
  <div class="text-center mt-1   mb-2 h-full   ">
    <div class="mt-1 h-1 bg-[#FF6E00] rounded-lg shadow-lg w-full"></div>
  </div>

  <template v-if="false">
  <!-- Quinta columna -->
  <div class="text-center mt-0  pl-1   h-full ">
    <span class="text-xs font-bold">{{ $t('oxigeno_saturado') }} %</span>
  </div>
  </template>

  <template v-if="false">
  <!-- Sexta columna -->
  <div class="text-center  h-full flex flex-col justify-center">
    <div class="flex justify-between">
      <div class="w-1/2 text-left">
        <div class="mt-1 h-1 bg-[#7fff00] shadow-lg ml-auto"></div>
      </div>
      <div class="w-1/2 text-right">
        <div class="mt-1 h-1 bg-[#395172] shadow-lg ml-auto"></div>
      </div>
    </div>
    <div class="flex justify-between mt-1">
      <div class="w-1/2 text-left pr-1">
        <span class="text-[#69ce04] text-xs">{{ $t('con_inyeccion') }}</span>
      </div>
      <div class="w-1/2 text-left ml-2">
        <span class="text-[#395172] text-xs">{{ $t('sin_inyeccion') }}</span>
      </div>
    </div>
  </div>
  </template>

    </div>
    <!-- Fin leyendas -->


    <div v-if="this.objJaulasOcultas.length > 0" class="grid xs:grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-1">
      <div class="container mx-auto  p-3 bg-gray-200 mt-3 text-black">
        {{ msg_jaulas_ocultas }}
      </div>
    </div>


    <div v-if="dataLoaded" class="grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2  mt-4">
      {{ error_load }}

      <template v-if="inclFB">GraficosLiveCentros: healthStatuses={{ healthStatuses }}<br></template>
      <template v-if="inclFB">GraficosLiveCentros: healthDataSets={{ healthDataSets }}<br></template>

      <div v-for="objJaula in objJaulas" :key="objJaula.id"
        class="bg-white w-100 overflow-hidden   shadow-md rounded-md mb-4 p-0">
        <template v-if="inclFB">GraficosLiveCentros: healthStatuses[{{ objJaula.id }}]={{ healthStatuses[objJaula.id] }}<br></template>
        <template v-if="inclFB">GraficosLiveCentros: before chart<br></template>
        <div class="p-1">
          <GraficoUnidadHighChart v-if="this.$store.state.gotolive !== true" :propIdFaena="propIdFaena"
            :startDate="startDate" :endDate="endDate" @ampliaGrafico="ampliaGrafico" :objJaula="objJaula">
          </GraficoUnidadHighChart>
          <GraficoUnidadHighChartLive v-if="this.$store.state.gotolive == true" :propIdFaena="propIdFaena"
            :invervalohoraslive="invervalohoraslive" @ampliaGraficoLive="ampliaGraficoLive" :objJaula="objJaula"
            @healthDataUpdate="healthDataSetsUpdate(objJaula.id, $event)"
            @healthStatusUpdate="healthStatusesUpdate(objJaula.id, $event)"
            >
          </GraficoUnidadHighChartLive>
        </div>
        <template v-if="inclFB">GraficosLiveCentros: after chart<br></template>
        <template v-if="inclFB">GraficosLiveCentros: healthDataSets[{{ objJaula.id }}]={{ healthDataSets[objJaula.id] }}<br></template>
        <template v-if="inclFB">GraficosLiveCentros: healthStatuses[{{ objJaula.id }}]={{ healthStatuses[objJaula.id] }}<br></template>
      </div>

      <template v-if="inclFB">GraficosLiveCentros: healthDataSets={{ healthDataSets }}<br></template>
      <template v-if="inclFB">GraficosLiveCentros: healthStatuses={{ healthStatuses }}<br></template>

    </div>


  </div>

  <template v-if="inclFB">GraficosLiveCentros: end template<br></template>

</template>

<script>
import { mapGetters } from "vuex";
import i18n from '@/i18n';
import ModalGraficoUnidadLive from "./modal/ModalGraficoUnidadLive.vue";
import ModalGraficoUnidad from "./modal/ModalGraficoUnidad.vue";
import GraficoUnidadHighChart from "./GraficoUnidadHighChart";
import GraficoUnidadHighChartLive from "./GraficoUnidadHighChartLive";
  
export default {
  name: "FaenasCliente",
  props: ["idEmpresa", "propIdFaena", "numRan", "propObjJaulas", "storeJaulas", "propRangoFechas","invervalohoras"],
  emits: ["chgFaena", 'healthDataSetsUpdate', 'healthStatusesUpdate'],
  components: {
    GraficoUnidadHighChart,
    GraficoUnidadHighChartLive,
      
    ModalGraficoUnidadLive,

    ModalGraficoUnidad,
   
  },
  mounted() {

    this.idFaena = this.propIdFaena;
    this.dataLoaded = false
    this.getDivisionesApi();

    this.dataLoaded = true;
    // this.loadUnidades();
    this.objJaulas = this.filtraVisibles(this.propObjJaulas);
    //const coincidencias = lineas.filter(l => l.includes("palabra"));
    console.log("objJaulas:::::", this.propObjJaulas)

  },
  data() {
    return {
      dataList: [],
      dataLoaded: false,
      datos_mensuales: [],
      trenes: [],
      //objJaulas: [],
      objJaulas: [],
      objJaulasOcultas: [],
      cards: [{}],
      error_load: '',
      seriesFaenas: [],
      dots: ["green", "yellow", "green", "red"],
      setpoint1: 0,
      setpoint2: 0,
      idEstado: 0,
      idFaena: this.propIdFaena,
      show: false,
      f: '',
      msg_jaulas_ocultas: '',
      fecha_paso: '',
      inclFB: false,
      injecta_fecha: '',
      invervalohoraslive:'0',
     
      startDate: '',
      endDate: '',
      modalgraficolivestate: false,
      modalgraficostate: false,
      chartOptionsPaso:'',
      legendsFullWidth:true,

      healthDataSets: {}, // hpia for all units
      healthStatuses: {}, // unitStatus[] = unitHealthStatus[] = collective health status = hpov[] = health processor output value array

    };
  },
  methods: {
    ampliaGraficoLive(obj) {

      this.modalgraficolivestate = true
      this.objJaulaSeleccionada = obj
    },
    ampliaGrafico(obj) {

      this.modalgraficostate = true
      this.objJaulaSeleccionada = obj
    },
    closeModalGraficoLive() {
      this.modalgraficolivestate = false
     this.$store.state.gotolive = true;

    },
    closeModalGrafico() {
      this.modalgraficostate = false
      this.$store.state.gotolive = true;
      
    },
    cambiarfecha() {
      this.injecta_fecha = this.fecha_paso;
    },

    filtraVisibles(f) {
      this.objJaulasOcultas = f.filter(item => item.visible === false);
      if (this.objJaulasOcultas.length > 0) {
        this.msg_jaulas_ocultas = "Jaulas ocultas: " + this.objJaulasOcultas.length
      }
      this.objJaulas = f.filter(item => item.visible === true);

      const traducidos = this.objJaulas.map(obj => ({
        ...obj,
        descripcion: obj.descripcion
                    .replace('Jaula', i18n.global.t('jaula'))
                    .replace('Plataforma', i18n.global.t('plataforma'))
      }));
      this.objJaulas = traducidos;

    },
    
    async getDivisionesApi() {
      //console.log("carga diviones", "id empresa");
      try {



        this.loadTree = true;
        this.loadMediciones = false;
        this.loadVistaplanta = false;







      } catch (err) {
        console.log(err);
      }
    },
     
    
    getFecCalendar(f) {


      this.startDate = this.convertirFormatoFecha(f[0]); //2023-11-01
      this.endDate = this.convertirFormatoFecha(f[1]);


    },

    convertirFormatoFecha(fechaOriginal) {
            if (!fechaOriginal) return false;
            const [dia, mes, año] = fechaOriginal.split(/\s+/);
            if (!dia || !mes || !año || año.length !== 4) return false;
            return  `${año}-${mes}-${dia}`;    
    },

    healthDataSetsUpdate(objid, hds) {
      this.healthDataSets[objid] = hds;
      this.$emit('healthDataSetsUpdate', this.healthDataSets);
    },

    healthStatusesUpdate(objid, hs) {
      this.healthStatuses[objid] = hs;
//      this.healthStatuses[objid+5] = hs;
//      this.healthStatuses[objid+10] = hs;
//      this.healthStatuses[objid+15] = hs;
//      this.healthStatuses[objid+20] = hs;
      this.$emit('healthStatusesUpdate', this.healthStatuses);
    }

  },
  computed: {
    ...mapGetters(["user", "token"]),

  },
  watch: {
    propRangoFechas: function (obj) {
      this.startDate = obj.startDate;
      this.endDate = obj.endDate;
    },
  

    propObjJaulas: function (value) {

    
      this.filtraVisibles(value);

      this.dataLoaded = true;
    },
    storeJaulas: function (value) {
      alert('detecta cambios')
      console.log(value)
    },
    invervalohoras: function(value){
      this.invervalohoraslive=value;
      this.$store.state.gotolive=true;
    }
  }

};
</script>
